import { deepmerge } from '@mui/utils';
import { defaultTheme } from 'react-admin';
import { CustomThemePalette } from './themeOverrides/CustomThemePalette';
import { Typography } from './themeOverrides/Typography';
import { breakpoints } from './themeOverrides/Breakpoints';
import { RaSidebarStyles } from './themeOverrides/components/RaSidebarStyles';
import { RaDatagridStyles } from './themeOverrides/components/RaDatagridStyles';
import { RaSimpleShowLayoutStyles } from './themeOverrides/components/RaSimpleShowLayoutStyles';
import { RaShowStylesStyles } from './themeOverrides/components/RaShowStyles';
import { MuiButtonStyles } from './themeOverrides/components/MuiButtonStyles';
import { MuiIconButtonStyles } from './themeOverrides/components/MuiIconButtonStyles';
import { MuiTextFieldStyles } from './themeOverrides/components/MuiTextFieldStyles';
import { MuiSelectStyles } from './themeOverrides/components/MuiSelectStyles';
import { MuiLinkStyles } from './themeOverrides/components/MuiLinkStyles';
import { MuiPaperStyles } from './themeOverrides/components/MuiPaperStyles';
import { MuiFormLabelStyles } from './themeOverrides/components/MuiFormLabelStyles';
import { MuiAutocompleteStyles } from './themeOverrides/components/MuiAutocompleteStyles';
import { MuiTablePaginationStyles } from './themeOverrides/components/MuiTablePaginationStyles';
import { MuiTableStyles } from './themeOverrides/components/MuiTableStyles';
import { MuiCheckboxStyles } from './themeOverrides/components/MuiCheckboxStyles';
import { MuiToolbarStyles } from './themeOverrides/components/MuiToolbarStyles';
import { MuiSwitchStyles } from './themeOverrides/components/MuiSwitchStyles';
import { MuiChipStyles } from './themeOverrides/components/MuiChipStyles';
import { MuiFormGroupStyles } from './themeOverrides/components/MuiFormGroupStyles';
import { MuiAlertStyles } from './themeOverrides/components/MuiAlertStyles';
import { MuiPopoverStyles } from './themeOverrides/components/MuiPopoverStyles';
import { MuiTooltipStyles } from './themeOverrides/components/MuiTooltipStyles';
import { MuiInputBaseStyles } from './themeOverrides/components/MuiInputBaseStyles';
import { RaAutocompleteInputStyles } from './themeOverrides/components/RaAutocompleteInputStyles';
import { RaTopToolbarStyles } from './themeOverrides/components/RaTopToolbar';
import { MuiSnackbarStyles } from './themeOverrides/components/MuiSnackbarStyles';
import { MuiDialogStyles } from './themeOverrides/components/MuiDialogStyles';
import { MuiDrawerStyles } from './themeOverrides/components/MuiDrawerStyles';
import { MuiFormHelperTextStyles } from './themeOverrides/components/MuiFormHelperTextStyles';
import { RaListStyles } from './themeOverrides/components/RaListStyles';
import { RaSingleFieldListStyles } from './themeOverrides/components/RaSingleFieldListStyles';

export const maasLoopTheme = deepmerge(defaultTheme, {
    palette: CustomThemePalette,
    typography: Typography,
    spacing: 4,
    breakpoints,
    components: {
        MuiTypography: {
            styleOverrides: {
                root: {
                    whiteSpace: 'pre-wrap',
                },
            },
        },
        RaSidebar: RaSidebarStyles,
        MuiPaper: MuiPaperStyles,
        MuiLink: MuiLinkStyles,
        RaDatagrid: RaDatagridStyles,
        RaShow: RaShowStylesStyles,
        RaSimpleShowLayout: RaSimpleShowLayoutStyles,
        MuiButton: MuiButtonStyles,
        MuiIconButton: MuiIconButtonStyles,
        MuiTextField: MuiTextFieldStyles,
        MuiFormLabel: MuiFormLabelStyles,
        MuiAutocomplete: MuiAutocompleteStyles,
        MuiSelect: MuiSelectStyles,
        MuiTablePagination: MuiTablePaginationStyles,
        MuiTable: MuiTableStyles,
        MuiCheckbox: MuiCheckboxStyles,
        MuiToolbar: MuiToolbarStyles,
        MuiSwitch: MuiSwitchStyles,
        MuiChip: MuiChipStyles,
        MuiFormGroup: MuiFormGroupStyles,
        MuiAlert: MuiAlertStyles,
        MuiPopover: MuiPopoverStyles,
        MuiTooltip: MuiTooltipStyles,
        MuiInputBase: MuiInputBaseStyles,
        RaAutocompleteInput: RaAutocompleteInputStyles,
        RaTopToolbar: RaTopToolbarStyles,
        MuiSnackbar: MuiSnackbarStyles,
        MuiDialog: MuiDialogStyles,
        MuiDrawer: MuiDrawerStyles,
        MuiFormHelperText: MuiFormHelperTextStyles,
        RaList: RaListStyles,
        RaSingleFieldList: RaSingleFieldListStyles,
    },
});
